module.exports = __webpack_public_path__ + "img/podcasts.ff1646e4.svg";